(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("React"));
	else if(typeof define === 'function' && define.amd)
		define("headerbundle", ["React"], factory);
	else if(typeof exports === 'object')
		exports["headerbundle"] = factory(require("React"));
	else
		root["headerbundle"] = factory(root["React"]);
})(this, (__WEBPACK_EXTERNAL_MODULE__1024__) => {
return 